export default __webpack_public_path__ + "static/background-0c9f1d8886c2e25c7f7a2e6bf75d4f5b.jpg";